import type { HeaderNavItem } from '../types/headerNav';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5001/api';

function adminHeaders(): Record<string, string> {
  const token = localStorage.getItem('adminToken');
  return {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
}

export function notifyHeaderNavUpdated() {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event('headerNavUpdated'));
  }
}

export const headerNavApi = {
  async getPublic(): Promise<HeaderNavItem[]> {
    const res = await fetch(`${API_BASE}/header-nav/public`);
    const json = await res.json();
    if (!json.success) throw new Error(json.message || 'Failed to load navigation');
    return json.data || [];
  },

  async getAdmin(): Promise<HeaderNavItem[]> {
    const res = await fetch(`${API_BASE}/admin/header-nav`, { headers: adminHeaders() });
    const json = await res.json();
    if (!json.success) throw new Error(json.message || 'Failed to load navigation');
    return json.data || [];
  },

  async save(items: HeaderNavItem[]): Promise<HeaderNavItem[]> {
    const res = await fetch(`${API_BASE}/admin/header-nav`, {
      method: 'PUT',
      headers: adminHeaders(),
      body: JSON.stringify({ items }),
    });
    const json = await res.json();
    if (!json.success) throw new Error(json.message || 'Failed to save navigation');
    notifyHeaderNavUpdated();
    return json.data || [];
  },

  async reset(): Promise<HeaderNavItem[]> {
    const res = await fetch(`${API_BASE}/admin/header-nav/reset`, {
      method: 'POST',
      headers: adminHeaders(),
    });
    const json = await res.json();
    if (!json.success) throw new Error(json.message || 'Failed to reset');
    notifyHeaderNavUpdated();
    return json.data || [];
  },
};
